<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('personalCompanyActivate.frdiXsProfilininAktivldirilmsi')" />
      <h4 class="mb-4">
        {{ $t('personalCompanyActivate.frdiXsProfilininAktivldirilmsi') }}
      </h4>

      <div class="row">
        <div class="col-xl-4 ">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <img
                  :src="getPhoto(user.profilePicture,'thumbnailCropped')"
                  class="img-thumbnail rounded-circle mb-3"
                  alt="companyLogo"
                  style="width: 200px;"
                >
                <h3>
                  {{ user.name }} {{ user.surname }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-xl-8 ">
          <div
            v-if="showCreateForm"
            class="card"
          >
            <div class="card-body">
              <p class="lead">
                {{ $t('companyPage.yeniProfil') }}
              </p>

              <p class="text-danger">
                {{ $t('companyPage.daxilEdiyinizMlumatlar') }} <strong>
                  {{ getProfileName() }}</strong> {{ $t('companyPage.n') }}
                {{ $t('companyPage.istiqamtiZrLaqMlumatlardrVHrKsNAqOlacaq') }}
              </p>

              <form @submit.prevent="createCompany">
                <div class="row">
                  <div class="col-6 mb-3">
                    <label>{{ $t('companyPage.telefon') }}</label>
                    <input
                      v-model="phoneNumber"
                      type="tel"
                      class="form-control"
                      required
                    >
                  </div>
                  <div class="col-6 mb-3">
                    <label>E-mail *</label>
                    <input
                      v-model="email"
                      type="email"
                      class="form-control"
                      required
                    >
                  </div>
                  <div class="col-6 mb-3">
                    <label>{{ $t('companyPage.websayt') }}</label>
                    <input
                      v-model="website"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="mb-3">
                  <label>{{ $t('companyPage.vzifniz') }}</label>
                  <input
                    v-model="profilePosition"
                    type="text"
                    class="form-control"
                    required
                  >
                </div>
                <div class="mb-3">
                  <label>{{ $t('companySearch.faliyytSahlri') }}</label>
                  <div class="mt-1">
                    <button
                      v-b-modal.modal-sector-selection
                      type="button"
                      class="btn btn-sm btn-light-primary"
                    >
                      {{ $t('companyProfile.faliyytSahsiniSein') }}
                    </button>
                  </div>

                  <hr v-if="selectedSectors.length>0">
                  <SelectedSectorView
                    :sectors="selectedSectors"
                    :parent-id="0"
                  />

                  <span>
                    {{ $t('personalCompanyActivate.maksimum5FaliyytSahsiSeBilrsiniz') }}
                  </span>
                </div>

                <div class="mb-3">
                  <button
                    type="submit"
                    class="btn btn-primary mb-2"
                  >
                    {{ $t('changeAccount.profilYarat') }}
                  </button>
                  <br>
                  <a
                    class="text-primary "
                    @click.prevent="showCreateForm = false"
                  >
                    {{ $t('companyPage.baqaProfilSe') }}
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div v-else>
            <div class="card">
              <div class="card-body">
                <div class=" lead">
                  {{ $t('companyPage.yalnizBirFaliyytYnnSeBilrsizBuHaldaPortaldaBtnFunk') }}
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('PROCUREMENT')"
                  >
                    <img
                      src="../../../assets/images/icons/procurement.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.satnalma') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('SUPPLIER')"
                  >
                    <img
                      src="../../../assets/images/icons/supplier.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.tdark') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('LOGISTIC')"
                  >
                    <img
                      src="../../../assets/images/icons/truck.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.logistika') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('TRUCK')"
                  >
                    <img
                      src="../../../assets/images/icons/truck.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.trSahibi') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <Sector_selection_modal
        :max-selection="20"
        :max-parent-selection="5"
        :parent-sector="null"
        :selected="selectedSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {createPersonalCompany,} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getPhoto, getProfileName} from "@/repositories/Utils";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";

import SelectedSectorView from "@/components/SelectedSectorsView.vue";

export default {
  components: {SelectedSectorView,Sector_selection_modal},
  data() {
    return {
      mediaBase: mediaBase,
      showCreateForm: false,
      selectedProfile: null,
      profiles: this.$t('profileNames'),
      selectedSectors: [],
      phoneNumber: '',
      email: '',
      website: '',
      profilePosition: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  watch: {
    user(val) {
      if (val?.personalCompanyCreated) {
        this.$router.push({name: 'changeAccount'});
      }
    }
  },
  mounted() {
    if (this.user?.personalCompanyCreated) {
      this.$router.push({name: 'changeAccount'});
    }
    this.phoneNumber= this.user.phone;
    this.email = this.user.email;
  },
  methods: {
    openProfileForm(profileType) {
      this.showCreateForm = true;
      this.selectedProfile = profileType;
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    sectorSelected(sectors) {
      this.selectedSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createCompany() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      if (this.selectedSectors.length === 0) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("flyytShsSclmb"),
          icon: 'warning'
        })
        return;
      }
      let data = {
        phone: this.phoneNumber,
        email: this.email,
        website: this.website,
        linkedin: ''
      };

      let country = localStorage.getItem('country');
      createPersonalCompany(this.token, this.profilePosition, this.selectedProfile, sectors,country , JSON.stringify(data)).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("frdSxsHsbnzAktv"),
            icon: 'success'
          }).then(() => {
            this.$router.replace({name: 'changeAccount'});
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
